import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Page, Toast } from '@shopify/polaris';
import PlanChangeComponent from './EnablePlans/PlanChangeComponent';
import FeatureList from './FeatureList';
import {
  NEW_FREE_PLAN_FEATURE_LIST,
  SMALL_BUSINESS_PLAN_LIST,
  OLD_FREE_PLAN_FEATURE_LIST,
  OLD_PRO_PLAN_FEATURE_LIST,
  OLD_ULTIMATE_PLAN_FEATURE_LIST,
  NEW_USER_LIST,
  ENTERPRISE_PLAN_LIST,
} from '../../constants/Pricing/Features/constants';
import WabaConfiguration from './WabaConfiguration';
import PlanStatus from './PlanStatus';
import {
  getWabaDetailsbyShopId,
  loadWabaDetails,
} from '../../redux/actions/private-waba';
import {
  PLAN_OLD_FREE,
  PLAN_NEW_FREE,
  PLAN_OLD_PRO,
  PLAN_OLD_ULTIMATE,
  PLAN_SMALL_BUSINESS,
  PLAN_ENTERPRISE,
  REACT_TOUR_STEPS,
} from '../../constants/constants';
import SetupWarnCard from './SetupWarnCard/SetupWarnCard';
import PlanTour from './ProductTour/PlanTour';
import { getPlanDetails, updatePlan } from '../../redux/actions/pricing';
import { clevertapEventPush, CT_EVENT_IDS } from '../../utils/clevertapUtils';
import { sendCleverTapEvent_planUpdate } from '../../common/helperFunctions';

const HomePage = (props: any) => {
  const history = useHistory();
  const planId = JSON.parse(localStorage.getItem('currentPlan') || '{}');
  const shop = JSON.parse(localStorage.getItem('shop') || '{}');
  const owner = JSON.parse(localStorage.getItem('owner') || '{}');
  const [name, setName] = useState('');
  const [isWABAEnabled, setIsWABAEnabled] = useState(false);
  const [isPlanStatusVisible, setIsPlanStatusVisible] = useState(false);
  const NEW_USER = 0;
  const planMapping = {
    [PLAN_OLD_FREE]: OLD_FREE_PLAN_FEATURE_LIST,
    [PLAN_OLD_PRO]: OLD_PRO_PLAN_FEATURE_LIST,
    [PLAN_OLD_ULTIMATE]: OLD_ULTIMATE_PLAN_FEATURE_LIST,
    [PLAN_NEW_FREE]: NEW_FREE_PLAN_FEATURE_LIST,
    [PLAN_SMALL_BUSINESS]: SMALL_BUSINESS_PLAN_LIST,
    [PLAN_ENTERPRISE]: ENTERPRISE_PLAN_LIST,
    [NEW_USER]: NEW_USER_LIST,
  };

  const location = useLocation();
  const currentPlanId = JSON.parse(localStorage.getItem('currentPlan') || '{}');
  const [toast, setToast] = useState({ show: false, message: '' });
  const [errorToast, setErrorToast] = useState({ show: false, message: '' });
  const queryParam = new URLSearchParams(location.search);
  const queryParamPlanId = queryParam.get('id');
  const [planTourData, setPlanTourData] = useState({});
  const [homePageTourShown, setHomePageTourShown] = useState(false);

  const fetchPlanDetails = async (planId: string) => {
    await getPlanDetails(planId).then((res: any) => {
      if (res) {
        localStorage.setItem('features', res.plan.featuresList);
      }
    });
  };

  useEffect(() => {
    if (queryParam.has('id')) {
      let planId: string = queryParam.get('id') || '';
      localStorage.setItem('currentPlan', planId);
      setToast({ show: true, message: 'Plan Activated Successfully' });
      queryParam.delete('id');
      history.replace({
        search: queryParam.toString(),
      });
      history.push('/home');
      window.location.reload();
    }
  }, [queryParamPlanId]);

  const handleUpdatePlan = (planId: number, page: any) => {
    if (Number(currentPlanId) === planId) return null;
    clevertapEventPush({
      eventId: CT_EVENT_IDS.SUBSCRIBE_CLICKED,
      eventData: {
        'Upgrading to': planId,
        page: page,
      },
    });
    activatePlan(planId);
  };

  const activatePlan = (planId: number) => {
    let shop = JSON.parse(localStorage.getItem('shop') || '{}');
    let params = {
      from: 'pricing',
      returnUrl: window.location.origin + '/confirmation'
    }
    updatePlan(shop.userId, planId.toString(), params).then(
      async (res: any) => {
        if (res.status === 'success' || res === 202) {
          await fetchPlanDetails(planId.toString());
          sendCleverTapEvent_planUpdate(planId, shop);
          if (res.charge && res.charge.confirmationUrl) {
            window.open(res.charge.confirmationUrl, '_self');
          } else {
            setToast({ show: true, message: 'Plan Activated Successfully' });
          }
        } else {
          setErrorToast({ show: true, message: res });
        }
      },
      () => {}
    );
  };

  const toggleToast = (message: string) => {
    setToast({
      show: !toast.show,
      message: message,
    });
  };

  const toggleErrorToast = (message: string) => {
    setErrorToast({
      show: !errorToast.show,
      message: message,
    });
  };

  const toastMarkup = toast.show ? (
    <Toast
      content={toast.message}
      onDismiss={() => {
        toggleToast('');
      }}
    />
  ) : null;

  const errorToastMarkup = errorToast.show ? (
    <Toast
      error
      content={errorToast.message}
      onDismiss={() => {
        toggleErrorToast('');
      }}
    />
  ) : null;

  const checkNewUser = () => {
    if (
      Number(shop.createdOn) >
      Number(process.env.REACT_APP_PLAN_NEW_USER_START_DATE)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getFeatureList = () => {
    let tempId = planId;
    if (checkNewUser() && planId == PLAN_OLD_FREE) {
      tempId = NEW_USER;
    }
    return planMapping[tempId];
  };
  useEffect(() => {
    setIsPlanStatusVisible(
      JSON.parse(localStorage.getItem('planStatus_clicked') || '{}') == true
        ? false
        : true
    );
    if (checkNewUser() && planId == PLAN_OLD_FREE) {
      setIsPlanStatusVisible(false);
    }
    loadWabaDetails(shop.userId).then((res: any) => {
      if (res && res.appId && res.whatsappVerificationStatus) {
        setIsWABAEnabled(true);
      } else {
        getWabaDetailsbyShopId(shop.userId).then((res: any) => {
          if (res && res.appId && res.whatsappVerificationStatus) {
            setIsWABAEnabled(true);
          }
        });
      }
    });
    if (owner.name) {
      setName(owner.name);
    }
  }, []);

  useEffect(() => {
    if(planId === PLAN_NEW_FREE) setPlanTourData(REACT_TOUR_STEPS.PLAN_NEW_FREE);
    if(planId === PLAN_SMALL_BUSINESS) setPlanTourData(REACT_TOUR_STEPS.PLAN_GROWTH);
    if(planId === PLAN_ENTERPRISE) setPlanTourData(REACT_TOUR_STEPS.PLAN_ENGAGE);
    let productTourViewed = JSON.parse(sessionStorage.getItem('productTourViewed') || '[]');
    let pathName = location.pathname === '/' ? `/home_${planId}` : `${location.pathname}_${planId}`;
    if(!productTourViewed.includes(pathName)) setHomePageTourShown(true);
  }, [planId])

  return (
    <>
      {![PLAN_OLD_FREE, PLAN_OLD_PRO, PLAN_OLD_ULTIMATE].includes(planId) &&
        homePageTourShown &&
        Object.keys(planTourData).length && (
          <PlanTour planTourData={planTourData} shopId={shop} planId={planId} />
        )}
      <Page title={`Hello, ${name} !`}>
        {toastMarkup}
        {errorToastMarkup}
        {isPlanStatusVisible && (
          <PlanStatus
            planId={planId}
            setIsPlanStatusVisible={setIsPlanStatusVisible}
          />
        )}
        {[PLAN_OLD_FREE].includes(planId) && (
          <SetupWarnCard
            title={
              <div className='mainTitle'>
                Update to the <p className='green'>New FREE Plan</p>
              </div>
            }
            subtitle={'Get additional features without paying an extra penny.'}
            description={`Hello Customer, you are currently using the older version of Superlemon Free plan which doesn't have the new features available in the New Free Plan ($0 subscription plan). We would recommend you to upgrade to the New Free Plan and make the full use of the Superlemon plugin to engage with your customers via WhatsApp.`}
            onSubmit={() => {
              handleUpdatePlan(PLAN_NEW_FREE, 'Homepage');
            }}
            btnText={'Update Plan'}
          />
        )}
        {[PLAN_NEW_FREE, PLAN_SMALL_BUSINESS, PLAN_ENTERPRISE].includes(
          planId
        ) && <WabaConfiguration isWABAEnabled={isWABAEnabled} />}
        <PlanChangeComponent />
        <FeatureList plan={getFeatureList()} />
      </Page>
    </>
  );
};

export default HomePage;
